import React from 'react';
import { ReviewTemplateProps } from '../types';
import StarRating from '../../components/StarRating';
import { formatRecommendationDisplay, getRatingNumber } from '../../utils/formatters';
import { lightenColor } from '../../utils/colorUtils';
import SourceLogo from '../components/SourceLogo';

const ShareReviewTemplate3: React.FC<ReviewTemplateProps> = ({
    reviewerName,
    reviewText,
    rating,
    network,
    color = '#14b8a6',
    logo,
    showLogo,
    showSource,
}) => {
    const numericRating = getRatingNumber(rating);
    const isFacebookRecommendation =
        network === 'facebook' && (rating === 'positive' || rating === 'negative');

    const lightColor = lightenColor(color, 70);

    return (
        <div
            className="w-[1080px] h-[1080px] px-24 pt-24 pb-11 relative rounded-[20px] inline-flex flex-col justify-start items-center gap-10 overflow-hidden"
            style={{ backgroundColor: lightColor }}
        >
            <div
                style={{
                    position: 'absolute',
                    width: '1306.34px',
                    height: '240px',
                    left: '-114.61px',
                    top: '491.50px',
                    transform: 'rotate(-15deg)',
                    transformOrigin: 'top left',
                    backgroundColor: color,
                }}
            />

            <div className="w-[193.03px] h-40 right-[165px] top-[45px] absolute z-[1000]">
                <svg
                    width="194"
                    height="160"
                    viewBox="0 0 194 160"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M133.71 81.0323C118.742 74.8387 109.452 61.4193 109.452 42.3225C109.452 17.0322 127.516 -5.73042e-06 150.742 -3.69996e-06C175.516 -1.53413e-06 193.064 17.5484 193.064 42.3226C193.064 54.1935 191 62.9677 181.71 86.7097L154.355 160L113.064 160L133.71 81.0323ZM24.2903 81.0322C9.32252 74.8387 0.0321894 61.4193 0.0321911 42.3225C0.0321933 17.0322 18.0967 -1.52962e-05 41.3225 -1.32657e-05C66.0967 -1.10999e-05 83.6451 17.5484 83.6451 42.3225C83.6451 54.1935 81.5806 62.9677 72.2903 86.7097L44.9354 160L3.64511 160L24.2903 81.0322Z"
                        fill={color}
                    />
                </svg>
            </div>

            <div className="self-stretch flex-1 p-10 bg-white rounded-[40px] flex flex-col justify-between items-start relative overflow-hidden">
                <div
                    className="absolute bottom-0 left-0 right-0 h-[120px] rounded-b-[40px]"
                    style={{ backgroundColor: color }}
                />

                <div className="self-stretch flex flex-col justify-start items-start gap-12 relative z-10">
                    <div className="flex flex-col justify-center items-start gap-1">
                        {!isFacebookRecommendation && (
                            <StarRating rating={numericRating} iconSize={'h-[67px]'} />
                        )}
                    </div>

                    <div
                        className={`self-stretch text-left text-black text-5xl font-semibold font-['Montserrat'] leading-[57.60px] ${isFacebookRecommendation && 'pt-[50px]'}`}
                    >
                        {reviewText}
                    </div>
                </div>
                {isFacebookRecommendation ? (
                    <div className="self-stretch inline-flex justify-between items-center relative z-20">
                        <div className="text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                            {reviewerName}
                        </div>
                        <div>{formatRecommendationDisplay(rating, 'template3')}</div>
                    </div>
                ) : (
                    <div className="self-stretch text-left text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px] relative z-20">
                        {reviewerName}
                    </div>
                )}
            </div>

            <div
                className={`self-stretch inline-flex items-center z-[1000] ${showLogo && logo && showSource ? 'justify-between' : showLogo && logo ? 'justify-start' : showSource ? 'justify-end' : 'justify-center'}`}
            >
                {showLogo && logo && (
                    <img
                        src={logo}
                        alt="Logo"
                        className="h-24 object-contain"
                        crossOrigin="anonymous"
                    />
                )}
                {showSource && <SourceLogo network={network} template="template1" />}
            </div>
        </div>
    );
};

export default ShareReviewTemplate3;
